module.exports = __webpack_public_path__ + "img/cocos_6.fd90d58f.jpg";